import React, { useState, useEffect } from "react";
import Filter from "./Filter";
import Column from "./Column";
import DownloadReports from "./DownloadReports";
import AppliedFilters from "./AppliedFilters";
import ResendAndCancel from "./ResendAndCancel";
import CategoryTab from "./CategoryTab";
import SavedFilters from "./SavedFilters";
import styled from "styled-components";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchSavedFilter } from "../../../../../actions/reportAction";
import { REWARD_TYPES } from "../../constants";
import DateFilter from "./DateFilter";

const chipProps = {
  active: {
    color: "custom",
    backgroundColor: "primary",
    backgroundShade: "c05",
  },
  unactive: {
    color: "custom",
    backgroundColor: "light",
    backgroundShade: "c000",
  },
};

const StyledDiv = styled.div.attrs()`
  height: 36px;
`;

const ReportsFilter = (props) => {
  const {
    type,
    title,
    downloadReport,
    preparingToDownload,
    count,
    reportsData,
    columns,
    setColumns,
    applyFilter,
    activeTab,
    loading,
    selectedRows,
    selectedCategory,
    setSelectedCategory,
    tableData,
    maxDownloadRows,
    employee_email,
    reportReducer,
    initialColumns,
    isReportLoading,
    hideReportOptions,
    isFilterDisabled,
    tpdCustomColumns,
    kyb_status,
  } = props;

  const [savedFilters, setSavedFilters] = useState([]);
  const [selectedFilterIndex, setSelectedFilterIndex] = useState(-1);

  useEffect(() => {
    if (
      ["reward points", "reward code", "reward link", "gift cards"].includes(
        title
      )
    ) {
      props.fetchSavedFilter(activeTab);
    } else {
      setSavedFilters([]);
    }
  }, [activeTab]);

  useEffect(() => {
    if (reportReducer) {
      if (title === "reward points") {
        setSavedFilters(reportReducer.xoxoPointSavedFilter);
      } else if (title === "reward code") {
        setSavedFilters(reportReducer.xoxoCodeSavedFilter);
      } else if (title === "reward link") {
        setSavedFilters(reportReducer.xoxoLinkSavedFilter);
      } else if (title === "gift cards") {
        setSavedFilters(reportReducer.plumProSavedFilters);
      }
    }
  }, [reportReducer]);
  return (
    <>
      <StyledDiv className="d-flex justify-content-end align-items-center mt-28 mb-16">
        {savedFilters.length > 0 && selectedCategory === 0 && (
          <SavedFilters
            initialColumns={initialColumns}
            setColumns={setColumns}
            savedFilters={savedFilters}
            chipProps={chipProps}
            setSelectedCategory={setSelectedCategory}
            selectedFilterIndex={selectedFilterIndex}
            setSelectedFilterIndex={setSelectedFilterIndex}
            hideReportOptions={hideReportOptions}
            applyFilter={applyFilter}
          />
        )}
        <div className="mr-auto">
          {tableData.data.length > 1 && (
            <CategoryTab
              title={title}
              categories={tableData.data}
              selectedCategory={selectedCategory}
              setSelectedCategory={setSelectedCategory}
              setSelectedFilterIndex={setSelectedFilterIndex}
            />
          )}
        </div>
        <ResendAndCancel
          activeTab={activeTab}
          reportsData={reportsData}
          selectedRows={selectedRows}
          columns={columns}
          setColumns={setColumns}
          title={title}
          selectedCategory={selectedCategory}
        />
        {(title === "payments" || title === "invoice payments") &&
          type === "xoxo_token_report" && (
            <>
              <div className="ml-12">
                <DateFilter
                  initialColumns={columns}
                  applyFilter={applyFilter}
                  chipProps={chipProps}
                  reportsData={reportsData}
                  hideReportOptions={hideReportOptions}
                  isFilterDisabled={isFilterDisabled}
                  selectedFilterIndex={selectedFilterIndex}
                  title={title}
                  type={type}
                />
              </div>
            </>
          )}

        {(selectedCategory === 0 ||
          (selectedCategory === 1 &&
            ["reward link", "discount store history"].includes(title)) ||
          (["invoice payments", "payments"].includes(title) &&
            selectedCategory >= 0)) && (
          <>
            {columns.length > 0 && (
              <Filter
                initialColumns={columns}
                applyFilter={applyFilter}
                chipProps={chipProps}
                reportsData={reportsData}
                hideReportOptions={hideReportOptions}
                isFilterDisabled={isFilterDisabled}
                selectedFilterIndex={selectedFilterIndex}
                title={title}
                type={type}
              />
            )}

            <div className="ml-12">
              <Column
                columns={columns}
                setColumns={setColumns}
                chipProps={chipProps}
                reportsData={reportsData}
                hideReportOptions={hideReportOptions}
                tpdCustomColumns={tpdCustomColumns}
                // filterColumnData={tableHeader}
                // updateState={this.props.updateStateParent}
                // showText={true}
                // currencyCode={currencyCode}
              />
            </div>
            <div className="ml-12">
              <DownloadReports
                kyb_status={kyb_status}
                columns={columns}
                downloadReport={downloadReport}
                preparingToDownload={preparingToDownload}
                loading={loading}
                maxDownloadRows={maxDownloadRows}
                employee_email={employee_email}
                chipProps={chipProps}
                reportsData={reportsData}
                isReportLoading={isReportLoading}
                hideReportOptions={hideReportOptions}
                title={title}
                type={type}
                // showDownload={showDownload}
                // filename={filename}
                count={count}
                // showDownloaded={showDownloaded}
                // handleDownlaod={this.props.handleDownlaod}
                // showText={true}
                // reward_type={this.props.reward_type}
                // employee_email={employee_email}
              />
            </div>
          </>
        )}
      </StyledDiv>

      {columns && columns.length > 0 && (
        <AppliedFilters
          initialColumns={initialColumns}
          selectedCategory={selectedCategory}
          activeTab={activeTab}
          columns={columns}
          setColumns={setColumns}
          applyFilter={applyFilter}
          selectedFilterIndex={selectedFilterIndex}
          setSelectedFilterIndex={setSelectedFilterIndex}
          reportsData={reportsData}
          type={type}
          hideReportOptions={hideReportOptions}
          title={title}
        />
      )}
    </>
  );
};
const mapStateToProps = (state) => {
  const { reportReducer } = state;
  return {
    reportReducer,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchSavedFilter: (reward_type) => fetchSavedFilter(reward_type),
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ReportsFilter);
